/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipment_Status_ExceptionInputs */

const en_shipment_status_exception = /** @type {(inputs: Shipment_Status_ExceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exception`)
};

/**
* | output |
* | --- |
* | "Exception" |
*
* @param {Shipment_Status_ExceptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shipment_status_exception = /** @type {((inputs?: Shipment_Status_ExceptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipment_Status_ExceptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shipment_status_exception(inputs)
});